import RCSlider from 'rc-slider';
import 'rc-slider/assets/index.css';
import styled from 'styled-components';

export const Wrapper = styled(RCSlider)`
  &.rc-slider-disabled {
    background-color: unset;
  }
  .rc-slider-handle-dragging {
    box-shadow: none !important;
  }
  .rc-slider-handle[aria-valuenow='0'] {
    margin-left: 7px;
  }
  &.reverse .rc-slider-handle {
    margin-right: -7px;
  }

  .rc-slider-handle::after {
    content: '||';
    font-size: 10px;
    position: absolute;
    left: 3px;
    color: ${({ theme }) => theme.colorTextPrimaryButton};
  }
`;
